import React from "react";

import Accordion from "@visa/vds/accordion";
import AccordionItem from "@visa/vds/accordion-item";
import AccordionHeading from "@visa/vds/accordion-heading";
import AccordionTitle from "@visa/vds/accordion-title";
import AccordionBody from "@visa/vds/accordion-body";

import Col from "@visa/vds/col";
import Row from "@visa/vds/row";

import EventInformation from "./EventInformation";

const ServiceAccordion = (props) => {
  const { serviceData, setServiceData, alertObj } = props;

  return (
    <>
      <Row>
        <Col>
          <Accordion>
            {serviceData &&
              serviceData
                .map((service, serviceId) => (
                  <AccordionItem key={"Accordion" + serviceId}>
                    <AccordionHeading>
                      <AccordionTitle>{service.name}</AccordionTitle>
                    </AccordionHeading>
                    <AccordionBody>
                      <EventInformation
                        alertObj={alertObj}
                        serviceIdx={serviceId}
                        setServiceData={setServiceData}
                        serviceData={serviceData}
                      />
                    </AccordionBody>
                  </AccordionItem>
                ))
                .filter((accordionItem) => accordionItem)}
          </Accordion>
        </Col>
      </Row>
    </>
  );
};

export default ServiceAccordion;
